import { isStablecoin } from '@/config/euler-contracts'
import type { AssetFilter } from '../types'

export function isHypeRelated(symbol: string): boolean {
  return symbol.toLowerCase().includes('hype')
}

export function matchesAssetFilter(assetSymbol: string | undefined, filter: AssetFilter): boolean {
  if (!assetSymbol) return false

  switch (filter) {
    case 'Stablecoins':
      return isStablecoin(assetSymbol)
    case 'HYPE':
      return isHypeRelated(assetSymbol)
    default:
      return false
  }
}
